// A run of 4+ digits that is not part of a decimal fraction, a date
// ("2020-01-01") or a ratio/path ("1/2020"): the lookbehind/lookahead skip any
// digit run touching a digit, '.', '-' or '/'.
const THOUSANDS_CANDIDATE = /(?<![\d.\-/])\d{4,}(?![\d\-/])/g;

/**
 * Adds thousands separators to the whole numbers inside a table cell value, e.g.
 * "12345" -> "12,345" and "12345 (45.6%)" -> "12,345 (45.6%)". Decimal
 * fractions, dates and short numbers are left as-is.
 */
export const formatCellValue = (value: string): string =>
  value.replace(THOUSANDS_CANDIDATE, (digits) => Number(digits).toLocaleString('en-US'));
